import "./sentry";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HeroUIProvider } from "@heroui/react";
import * as Sentry from "@sentry/react";
import axios from "axios";
import App from "./App.jsx";
import "./index.css";

axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;

// Capture API errors (5xx, timeout, network) ke Sentry
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error.response?.status;
        // Skip 401 (session expired) dan 422 (validation) — ini expected behavior
        if (status && status !== 401 && status !== 422) {
            Sentry.captureException(error, {
                tags: {
                    api_url: error.config?.url,
                    api_method: error.config?.method?.toUpperCase(),
                    status_code: status,
                },
            });
        }
        // Capture network error / timeout (no response)
        if (!error.response && error.code !== "ERR_CANCELED") {
            Sentry.captureException(error, {
                tags: { api_url: error.config?.url, error_code: error.code },
            });
        }
        return Promise.reject(error);
    },
);

createRoot(document.getElementById("root")).render(
    <StrictMode>
        <Sentry.ErrorBoundary
            fallback={
                <div className="flex h-screen flex-col items-center justify-center gap-4 bg-gray-50 px-6 text-center dark:bg-gray-900">
                    <div className="rounded-full bg-red-100 p-4 dark:bg-red-900/30">
                        <svg
                            className="h-10 w-10 text-red-500"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
                            />
                        </svg>
                    </div>
                    <h1 className="text-xl font-semibold text-gray-800 dark:text-gray-100">
                        Terjadi Kesalahan
                    </h1>
                    <p className="max-w-md text-sm text-gray-500 dark:text-gray-400">
                        Mohon maaf, terjadi kesalahan yang tidak terduga.
                        Silakan coba refresh halaman.
                    </p>
                    <button
                        onClick={() => window.location.reload()}
                        className="mt-2 rounded-lg bg-blue-600 px-5 py-2.5 text-sm font-medium text-white transition hover:bg-blue-700"
                    >
                        Refresh Halaman
                    </button>
                </div>
            }
        >
            <HeroUIProvider>
                <App />
            </HeroUIProvider>
        </Sentry.ErrorBoundary>
    </StrictMode>,
);
